/**
 * Generates an array of graduation year options for the past 25 years
 * based on the current year
 * @returns {Array<{value: number, label: string}>} Array of graduation year options
 */
export const generateGradYearOptions = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    
    // For grad applicants, we always want to include the current year
    // and go back 25 years from there
    return Array.from({ length: 26 }, (_, index) => {
        const year = currentYear - index;
        return {
            value: year,
            label: year.toString()
        };
    });
}; 